export class UiService {
    id: string;
    tags?: string;
    authorizations?: string[];
    label: string;
    avatar?: string;
    icon?: string;
    secondIcon?: string;
    translationKey?: string;
    cssClass ? = '';
    root?: boolean;
    show ? = true;
    childreen?: UiService[] = [];
    display?: {
        labelMoving?: boolean;
        containerType?: string
    };
    onClick?: () => any;
    url?: string;
    expanded ? = false;

    constructor(data: UiService) {
        for (const k of Object.keys(data)) {
            this[k] = data[k];
        }
        if (this.display === undefined) {
            this.display = {
                labelMoving: false,
                containerType: 'circle'
            };
        }
    }
}
